import axios from 'axios'

const baseConfig = {
  timeout: 20 * 1000,
  baseURL: process.env.VUE_APP_BASEURL
}

const request = axios.create(baseConfig)
request.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.authorization = token
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

request.interceptors.response.use(
  (response) => {
    if (response) {
      const { status, data } = response
      if (status && status !== 200) return Promise.reject(response)
      return data
    }
    return Promise.reject('接口返回异常')
  },
  (error) => {
    return Promise.reject(error)
  }
)

export { request }
